import type { ResolverConflitoLocalDialogProps } from "./types-resolver-conflito-local";
import { useResolverConflitoLocalDialog } from "./use-resolver-conflito-local";
import { ResolverConflitoLocalDialogView } from "./view-resolver-conflito-local";

/** Modal "Resolver Conflito de Alocação" do Local (HU 2042). */
export function ResolverConflitoLocalDialog(props: ResolverConflitoLocalDialogProps) {
  const vm = useResolverConflitoLocalDialog(props);

  return <ResolverConflitoLocalDialogView {...vm} />;
}

export type * from "./types-resolver-conflito-local";
